// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__lajhe","title":"InfoRow_title__3qq4h"};